// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"8c317515","456":"2ae19fff","606":"2ae19fff"}[chunkId] + ".chunk.css";
};